/**
 * Textos (`ca`) del tall «nonconformities» de Qualitat i APPCC (OBR-169). Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const nonConformitiesCa = {
  'backoffice.nonConformities': {
    subtitle: 'Registre únic de no conformitats i de les accions correctores',
    newNonConformity: 'Nova no conformitat',

    // Llista i filtres
    searchLabel: 'Cerca',
    searchPlaceholder: 'Codi, descripció, proveïdor, article o lot',
    filterStatusLabel: 'Estat',
    filterStatusActive: 'Actives',
    filterStatusAll: 'Totes',
    filterOriginLabel: 'Origen',
    filterOriginAll: 'Tots els orígens',
    filterFromLabel: 'Des del',
    filterToLabel: 'Fins al',
    clearFilters: 'Esborra els filtres',
    loadError: 'No s’han pogut carregar les no conformitats',
    empty: 'Encara no hi ha cap no conformitat.',
    emptyActive: 'No hi ha cap no conformitat activa. Tot en ordre.',
    emptyFiltered: 'Cap no conformitat coincideix amb els filtres.',

    // Estats i orígens
    statusOpen: 'Oberta',
    statusInProgress: 'En curs',
    statusClosed: 'Tancada',
    originReception: 'Recepció',
    originSelfCheck: 'Autocontrol',
    originProduction: 'Producció',
    originManual: 'Manual',
    originOther: 'Altres',

    // Targeta
    occurredAtLabel: 'Quan',
    reportedByLabel: 'Comunicada per',
    unknownUser: 'Persona desconeguda',
    automaticNoDetail: 'Oberta automàticament, sense més detall.',
    actionsProgress: '{{closed}} de {{total}} accions tancades',
    actionsNone: 'Sense accions correctores',
    actionsOverdue_one: '{{count}} acció vençuda',
    actionsOverdue_other: '{{count}} accions vençudes',
    openDetail: 'Obre',

    // Enllaços
    linkSupplier: 'Proveïdor',
    linkArticle: 'Article',
    linkSupplierLot: 'Lot del proveïdor',
    linkFinishedLot: 'Lot produït',
    linkReception: 'Albarà',
    linkIncident: 'Incidència',
    linkSelfCheck: 'Autocontrol',
    linkIncidentOpen: 'Veure la incidència',
    linkSelfCheckOpen: 'Veure els autocontrols',
    supplierLotCodeRef: 'lot del proveïdor {{code}}',

    // Detall
    sectionSummary: 'Què ha passat',
    sectionLinks: 'Origen',
    sectionAttachment: 'Foto o document',
    sectionActions: 'Accions correctores',
    sectionHistory: 'Historial',
    occurredAt: 'Data i hora',
    reportedBy: 'Comunicada per',
    closedBanner: 'Tancada el {{date}} per {{name}}: {{note}}',
    openAttachment: 'Obre el fitxer',
    attachmentError: 'No s’ha pogut obrir el fitxer.',
    readOnlyHint: 'Només administració, qualitat i producció poden canviar-la.',

    // Canvis d'estat
    moveToInProgress: 'Posa en curs',
    moveToOpen: 'Torna a oberta',
    closeNonConformity: 'Tanca la no conformitat',
    reopenNonConformity: 'Reobre la no conformitat',
    closeBlockedActions_one: 'Per tancar-la cal tancar abans {{count}} acció correctora.',
    closeBlockedActions_other: 'Per tancar-la cal tancar abans {{count}} accions correctores.',
    closeTitle: 'Tanca la no conformitat',
    closeBody:
      'Una no conformitat tancada, amb les seves accions, no es pot tocar fins que es reobri.',
    closeNoteLabel: 'Nota de tancament',
    closeNotePlaceholder: 'Què s’ha fet i per què es dona per resolta',
    closeConfirm: 'Tanca',
    reopenTitle: 'Reobre la no conformitat',
    reopenBody: 'Torna a estar oberta i es pot tornar a treballar. El motiu queda a l’historial.',
    reopenNoteLabel: 'Motiu',
    reopenNotePlaceholder: 'Per què es torna a obrir',
    reopenConfirm: 'Reobre',

    // Accions correctores
    addAction: 'Afegeix una acció',
    actionsEmpty: 'Encara no hi ha cap acció correctora.',
    actionsLockedHint: 'Reobre la no conformitat per afegir-hi o canviar accions.',
    actionNewTitle: 'Nova acció correctora',
    actionEditTitle: 'Edita l’acció correctora',
    actionDescriptionLabel: 'Què s’ha de fer',
    actionDescriptionPlaceholder: 'Per exemple: netejar i desinfectar la càmara',
    actionResponsibleLabel: 'Responsable',
    actionNoResponsible: 'Sense responsable',
    actionDueOnLabel: 'Data límit',
    actionAddConfirm: 'Afegeix',
    actionSaveConfirm: 'Desa',
    editAction: 'Edita',
    startAction: 'Posa en curs',
    backToOpenAction: 'Torna a oberta',
    closeAction: 'Tanca l’acció',
    reopenAction: 'Reobre l’acció',
    actionStatusOpen: 'Oberta',
    actionStatusInProgress: 'En curs',
    actionStatusClosed: 'Tancada',
    actionOverdue: 'Vençuda',
    actionResponsibleLine: 'Responsable: {{name}}',
    actionDueLine: 'Data límit: {{date}}',
    actionVerifiedLine: 'Verificada per {{name}} el {{date}}',
    actionVerificationLine: 'Verificació: {{note}}',
    verifyTitle: 'Tanca l’acció correctora',
    verifyBody: 'Per donar-la per feta cal deixar què s’ha comprovat. Queda a l’historial.',
    verifyLabel: 'Verificació',
    verifyPlaceholder: 'Què s’ha comprovat',
    verifyConfirm: 'Tanca l’acció',

    // Historial
    historyEmpty: 'Encara no hi ha cap moviment.',
    eventCreated: 'Comunicada',
    eventStatusChanged: 'Estat: {{from}} → {{to}}',
    eventActionAdded: 'Acció afegida: {{note}}',
    eventActionUpdated: 'Acció modificada: {{note}}',
    eventActionMoved: 'Acció: {{from}} → {{to}}. {{note}}',
    eventClosed: 'Tancada: {{note}}',
    eventReopened: 'Reoberta: {{note}}',
    eventByLine: '{{name}} · {{date}}',

    // Formulari de NC manual
    manualTitle: 'Nova no conformitat',
    manualBody:
      'Comunica una no conformitat que has vist. Es crea oberta i el sistema li assigna el codi.',
    manualDescriptionLabel: 'Què ha passat',
    manualDescriptionPlaceholder: 'Per exemple: farina rebuda amb el sac trencat',
    manualSupplierLabel: 'Proveïdor (opcional)',
    manualArticleLabel: 'Article (opcional)',
    manualLotLabel: 'Lot del proveïdor (opcional)',
    manualLotPickArticle: 'Tria primer l’article per veure’n els lots.',
    manualLotNone: 'Sense lot',
    manualLotNoLots: 'Aquest article encara no té cap lot d’entrada.',
    manualLotLoadError: 'No s’han pogut carregar els lots.',
    manualAttachmentLabel: 'Foto o document (opcional)',
    manualAttachmentChoose: 'Tria un fitxer',
    manualAttachmentHint: 'JPEG, PNG o PDF, fins a 10 MB.',
    manualAttachmentRemove: 'Treu el fitxer',
    manualCreateConfirm: 'Crea',
    searchSupplier: 'Cerca un proveïdor',
    noSupplierMatches: 'Cap proveïdor coincideix',
    searchArticle: 'Cerca un article',
    noArticleMatches: 'Cap article coincideix',
    noneOption: '—',

    // Validació i errors del servidor
    validationDescriptionRequired: 'Escriu què ha passat.',
    validationActionDescriptionRequired: 'Escriu què s’ha de fer.',
    errorGeneric: 'No s’ha pogut desar el canvi. Torna-ho a provar.',
    errorForbidden: 'No tens permís per fer aquest canvi.',
    errorNotFound: 'Aquesta no conformitat ja no existeix.',
    errorAlreadyClosed: 'Algú altre ja ha tancat aquesta no conformitat.',
    errorNotClosed: 'Aquesta no conformitat no està tancada.',
    errorOpenActions: 'Encara hi ha accions correctores sense tancar.',
    errorNoteRequired: 'Cal escriure una nota.',
    errorVerificationRequired: 'Per tancar l’acció cal indicar què s’ha comprovat.',
    errorDescriptionRequired: 'Cal escriure una descripció.',
    errorClosedLocked: 'La no conformitat és tancada: reobre-la per tocar-ne les accions.',
    errorResponsibleOnlyStatus:
      'El responsable només pot canviar l’estat i la verificació de l’acció.',
    errorUploadInvalidType: 'El fitxer ha de ser JPEG, PNG o PDF.',
    errorUploadTooLarge: 'El fitxer passa de 10 MB.',
    errorUploadFailed: 'No s’ha pogut pujar el fitxer. Comprova la connexió i torna-ho a provar.',

    // Resum d'una NC automàtica (recepció)
    reasonTemperatureRange: 'Temperatura de {{temperature}} ºC fora de rang ({{min}} a {{max}} ºC)',
    reasonTemperatureAbove: 'Temperatura de {{temperature}} ºC per sobre del màxim ({{max}} ºC)',
    reasonTemperatureBelow: 'Temperatura de {{temperature}} ºC per sota del mínim ({{min}} ºC)',
    reasonTemperature: 'Temperatura de {{temperature}} ºC fora de rang',
    reasonTemperatureUnknown: 'Temperatura fora de rang',
    reasonPackagingKo: 'Envasat no conforme',
    reasonLabelingKo: 'Etiquetatge no conforme',
    reasonDecisionRejected: 'Rebutjat al control de recepció',
    reasonDecisionAcceptedWithIncident: 'Acceptat amb incidència',
    reasonSelfCheckFailed: 'Autocontrol no superat',
    reasonUnknown: 'Motiu: {{code}}',
    // Resum d'una NC d'autocontrol
    selfCheckFailedRange: '{{label}}: {{value}} (rang {{min}} a {{max}})',
    selfCheckFailedBelowMin: '{{label}}: {{value}} (mínim {{min}})',
    selfCheckFailedAboveMax: '{{label}}: {{value}} (màxim {{max}})',
    selfCheckFailedValue: '{{label}}: {{value}}',
    selfCheckFailedKo: '{{label}}: KO',
    selfCheckFailedUnnamed: 'Un punt de l’autocontrol no ha passat',
  },
} as const;
